import React from "react"
import { Menu as MenuPrimitive } from "@base-ui/react/menu"
import cx from "classnames"
import Icon from "../icon"
import { itemStyles } from "./menu-item"

export type MenuSubmenuTriggerProps = {
  /** Item content — compose with Menu.ItemIcon, Menu.ItemLabel and Menu.ItemDescription */
  children?: React.ReactNode
  /** Whether the trigger is disabled */
  disabled?: boolean
  /** Whether the submenu should open on hover */
  openOnHover?: boolean
}

const submenuTriggerStyles = cx(itemStyles, "data-popup-open:bg-gray-900/[0.06]")

export function MenuSubmenuTrigger({ children, disabled, openOnHover }: MenuSubmenuTriggerProps) {
  return (
    <MenuPrimitive.SubmenuTrigger
      data-slot="menu-sub-trigger"
      disabled={disabled}
      openOnHover={openOnHover}
      className={submenuTriggerStyles}
    >
      {children}
      <Icon name="right" size="md" aria-hidden="true" data-slot="menu-item-trailing" />
    </MenuPrimitive.SubmenuTrigger>
  )
}

MenuSubmenuTrigger.displayName = "Menu.SubmenuTrigger"
